import styled from "styled-components";

export const SearchBarWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
`;
